import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";

export default class SideGalleryLandscape extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index : 0,
			open : 	false
			
		}
		this.handleGoTo 	= this.handleGoTo.bind(this);
    }
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-index'), false);
    }
    
    
  			
	render() {
		
		let gallery = this.props.gallery;
		let heading= this.props.heading;
		
		if (gallery) {
	    	const settings = {
				dots: 			false,
				arrows: 		true,
				infinite: 		true,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next })
			};
			
			return (				
				
				<div className="c-side-gallery-landscape c-side-gallery-landscape--landscape">
					<div className={'c-side-gallery-landscape__inner'}>
						<div className={'c-side-gallery-landscape__wrapper scope-slick scope-slick--' + gallery.length}>
							<Slider ref={slider => (this.slider = slider)} {...settings}>
								{gallery.map((slide,i) =>
									{
										return (
											<div className={'inner ' + slide.fitting} key={i}>							
												<FadeIn>
													{onload => (
														<img
															alt={''} 
															src={slide.left_src} 
															srcSet={slide.left_srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
												<FadeIn>
													{onload => (
														<img
															alt={''} 
															src={slide.right_src} 
															srcSet={slide.right_srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
											</div>
										)
									}
								)}
							</Slider>
						</div>
						<div className="c-side-gallery-landscape__footer">
							<div className="c-side-gallery-landscape__footer__inner">
								{gallery.map((slide,i) =>
									{
										if (this.state.index === i) {
											return (
												<>
													<p className="c-side-gallery-landscape__footer__caption c-side-gallery-landscape__footer__caption--left state-active" key={i} dangerouslySetInnerHTML={{__html:slide.left_caption}}></p>
													<p className="c-side-gallery-landscape__footer__caption c-side-gallery-landscape__footer__caption--right state-active" key={i} dangerouslySetInnerHTML={{__html:slide.right_caption}}></p>
												</>
											)
										} else {
											return (
												<>
													<p className="c-side-gallery-landscape__footer__caption c-side-gallery-landscape__footer__caption--left" key={i} dangerouslySetInnerHTML={{__html:slide.left_caption}}></p>
													<p className="c-side-gallery-landscape__footer__caption c-side-gallery-landscape__footer__caption--right" key={i} dangerouslySetInnerHTML={{__html:slide.right_caption}}></p>
												</>
											)
										}
									}
								)}
								<div className="c-side-gallery-landscape__footer__controls">
									{gallery.map((slide,i) =>
										{
											if (this.state.index === i) {
												return (
													<a href="#" className="c-side-gallery-landscape__footer__controls__item state-active" key={i} data-index={i} dangerouslySetInnerHTML={{__html:(i + 1) + '.'}} onClick={this.handleGoTo}></a>
												)
											} else {
												return (
													<a href="#" className="c-side-gallery-landscape__footer__controls__item" key={i} data-index={i} dangerouslySetInnerHTML={{__html:(i + 1) + '.'}} onClick={this.handleGoTo}></a>
												)
											}
										}
									)}
								</div>
							</div>
						</div>	
					</div>					
				</div>			
									
			);
			
		} else {
			return null;
		}
	}
}